import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { FIELD_NAME } from 'app/constants/BibConstants';
import { createBibFieldSelector } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { fieldShape } from 'app/shapes/bibPage';
import Contains from './Contains';

const CATEGORY = 'CONTAINS';
const selectFieldItem = createBibFieldSelector(CATEGORY, FIELD_NAME.CONTAINS_WORK);

export class ContainsContainer extends React.PureComponent {
  render() {
    const { fieldItem, trackFieldItemClick } = this.props;

    return fieldItem?.get('fieldValues', Immutable.List())?.size ? (
      <Contains
        containedWork={fieldItem.get('fieldValues')}
        trackFieldItemClick={fieldValue => trackFieldItemClick(CATEGORY, fieldItem, fieldValue)}
      />
    ) : null;
  }
}

ContainsContainer.propTypes = {
  fieldItem: fieldShape,
  trackFieldItemClick: PropTypes.func.isRequired
};

const mapStateToProps = state => ({ fieldItem: selectFieldItem(state) });

export default connect(mapStateToProps)(ContainsContainer);
